// Директива свайпа v-swipe, работает в мобилке
export default {
  bind: function(el, binding, vnode) {
    const touchPoint = {
      x: null,
      y: null,
    };

    const emit = v => {
      binding.value(v);
    };

    el.touchStartHandler = e => {
      e.preventDefault();
      touchPoint.x = e.touches[0].clientX;
      touchPoint.y = e.touches[0].clientY;
    };
    el.touchMoveHandler = e => {
      e.stopPropagation();
      if (!touchPoint.x || !touchPoint.y) return;
      let xDiff = touchPoint.x - e.touches[0].clientX;
      let yDiff = touchPoint.y - e.touches[0].clientY;
      if (Math.abs(xDiff) < 25 && Math.abs(yDiff) < 25) {
        return;
      }

      if (Math.abs(xDiff) >= Math.abs(yDiff)) {
        if (xDiff > 0) emit('right');
        else emit('left');
      } else {
        if (yDiff > 0) emit('bottom');
        else emit('top');
      }

      touchPoint.x = null;
      touchPoint.y = null;
    };

    el.addEventListener('touchstart', el.touchStartHandler);
    el.addEventListener('touchmove', el.touchMoveHandler);
  },
  unbind: function(el) {
    el.removeEventListener('touchstart', el.touchStartHandler);
    el.removeEventListener('touchmove', el.touchMoveHandler);
  },
};
